import Worker from 'worker-loader!./room-log-worker-src'

export const RoomLogWorker = {
	start: function({roomData, serverUrl}){
		if(this.worker) {
			console.warn('worker start already !!');
			return;
		}

		const init = () => {
			this.sendMessage('setLogPolicy', {
				url: serverUrl,
				agent: 'Gooroomee-Meeting',
				sendTerm: 1000*60,
				roomId: roomData.room.roomId,
				userId: roomData.me.userId,
				username: roomData.me.username,
				nickname: roomData.me.nickname
			});
		}

		try{
			// let path = './room-log-worker-src.js';
			// this.worker = new Worker(path);
			this.worker = new Worker();
			this.worker.onmessage = function(e){
				let data = e.data;
			}
			init();
		}catch(e){
			console.error(e);
		}
	},
	isEnabled: function(){
		return !!this.worker;
	},
	sendMessage: function(api, data){
		if(!this.isEnabled()){
			return;
		}

		var msg = {
			api: api,
			data: data
		};
		try{
			this.worker.postMessage(msg);
		}catch(e){
			console.error(e.stack, e);
		}
	}
}

